import React, { useEffect, useState } from "react"
import { Box, Grid } from "@material-ui/core"
import { CreatorMaster } from "../Creators"
import { ColumnBox } from "../Boxes"
import { TileButton } from "../Buttons"
import { TRIGGER_TYPE } from "../../data"
import ScheduleSourceTrigger from "./ScheduleSourceTrigger"
import EventSourceTrigger from "./EventSourceTrigger"
import { TextDivider } from "../TextDivider"

const { SCHEDULE, EVENT } = TRIGGER_TYPE

const TriggerCreator = ({ open, onClose, edit, isInline, cy = "TriggerCreator" }) => {
  const [type, setType] = useState(SCHEDULE)

  useEffect(() => {
    if (edit) {
      setType(edit.__typename === "ScheduleTrigger" ? SCHEDULE : EVENT)
    }
  }, [edit])

  const handleClose = () => {
    onClose && onClose()
  }

  const handleTypeChange = (newSource) => {
    setType(newSource)
  }

  const handleSubmit = async () => {
    //
  }

  const isEdit = edit != null

  const form = (
    <>
      {!isEdit && (
        <Box mb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ColumnBox flexGrow={1}>
                <TileButton
                  title="Scheduled"
                  description="Specify a schedule on which to run this trigger, for example every week"
                  active={type === SCHEDULE}
                  onClick={() => handleTypeChange(SCHEDULE)}
                  style={{ width: "100%" }}
                  data-cy="TileButton-schedule"
                />
              </ColumnBox>
            </Grid>
            <Grid item xs={12} md={6}>
              <TileButton
                title="Event based"
                description="Run this trigger when a specific event occurs in Operandio, for example a job becoming complete"
                active={type === "event"}
                onClick={() => handleTypeChange("event")}
                style={{ width: "100%" }}
                data-cy="TileButton-event"
              />
            </Grid>
          </Grid>
        </Box>
      )}
      {Boolean(type) && (
        <>
          {!isEdit && <TextDivider mb={2} />}

          {type === SCHEDULE && (
            <ScheduleSourceTrigger onSubmit={handleSubmit} onClose={handleClose} edit={edit} cy={cy} />
          )}
          {type === EVENT && <EventSourceTrigger onSubmit={handleSubmit} onClose={handleClose} edit={edit} cy={cy} />}
        </>
      )}
    </>
  )

  return (
    <CreatorMaster
      open={open}
      subject={type === SCHEDULE ? "Scheduled trigger" : "Event trigger"}
      form={form}
      isEdit={isEdit}
      isInline={isInline}
      onClose={handleClose}
    />
  )
}

export default TriggerCreator
